module.exports = __webpack_public_path__ + "img/ZG81_10.3afdcc0e.jpg";